// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ab4BE","text":"style_text__VxnQD","actions":"style_actions__zHDQL","actions_btn":"style_actions_btn__QkcbB"};